import { Inject, Injectable, PLATFORM_ID, Provider } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HTTP_INTERCEPTORS } from '@angular/common/http';
import { takeUntil, Observable } from 'rxjs';

import { getIgnoredEndpoints, RequestCancellationService } from '@hiptraveler/common';

const ignoredEndpoints = [
  '/assets/i18n',                       /* Global requests */
  'assets/base64-collection',
  'assets/icon-svg-collection.json',
  'googleads',
  'cloudfront.net',

  '/api/auth/refreshToken',             /* Auth requests */
  '/api/auth/userdetails/',
  '/api/auth/signout/',

  '/trip-planner/getBrandInfo/',        /* Auth requests */

  '/trip-planner/search/location',      /* Search requests */
  '/trip-planner/search/hotels',
  '/trip-planner/search/Itineraries',
  '/trip-planner/search/Adventure/location',
  '/trip-planner/search/Food/location',
  '/trip-planner/search/community',
  '/trip-planner/getBrandContent',
  
  '/trip-planner/addItinerary'          /* Create itinerary request */
];

@Injectable()
export class _RequestCancellationInterceptor implements HttpInterceptor {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private requestCancellation: RequestCancellationService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    ignoredEndpoints.push('/trip-planner/itinerary/');
    ignoredEndpoints.push('/trip-planner/readBlog/');
    if (isPlatformServer(this.platformId)) {
    }

    const additionalEndpoints = getIgnoredEndpoints();

    return ignoredEndpoints.concat(additionalEndpoints).some((path: string) => request.url.includes(path))
      ? next.handle(request)
      : next.handle(request).pipe( takeUntil(this.requestCancellation.cancellationSignal$) );
  }

}

export const RequestCancellationInterceptor: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: _RequestCancellationInterceptor,
  multi: true
}
